import React from "react"
import PlatformSettingTable from "./components/PlatformSettingTable/PlatformSettingTable"
import {PlatformSettingProvider} from "./store/usePlatformSettingContext"
import {Card} from "antd"
import PlatformSettingAdd from "./components/PlatformSettingAdd";

const PlatformSetting = () => {
    return (
        <div>
            <PlatformSettingProvider>
                <Card
                    title={"团购平台设置"}
                    extra={<PlatformSettingAdd/>}
                >
                    <PlatformSettingTable/>
                </Card>
            </PlatformSettingProvider>
        </div>
    )
}

export default PlatformSetting


// WEBPACK FOOTER //
// ./src/containers/PlatformSetting/index.js